export default "__VITE_ASSET__CFwkU9st__"